var React = require('react');

function PromoMarker (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Grupo_132","data-name":"Grupo 132","transform":"translate(-615 -452.022)"},[React.createElement("path",{"id":"Sustracción_1","data-name":"Sustracción 1","d":"M46.42,46h-.09L28.921,36.438,11.511,46h-.09V-28.978h35V46Z","transform":"translate(603.58 481)","fill":"#ff4646","key":0}),React.createElement("text",{"id":"PROMO","transform":"translate(636.5 460.5) rotate(-90)","fill":"#fff","fontSize":"12","fontFamily":"Poppins","fontWeight":"500","key":1},React.createElement("tspan",{"x":"-48.888","y":"0"},"PROMO"))]));
}

PromoMarker.defaultProps = {"width":"35","height":"74.98","viewBox":"0 0 35 74.98"};

module.exports = PromoMarker;

PromoMarker.default = PromoMarker;
